import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: 'slide-toggle.component.html',
  styleUrls: ['slide-toggle.component.scss'],
  host: {
    '[class.state-checked]': '!!value',
    '[class.state-disabled]': '!!disabled',
    '[class.state-readonly]': '!!readOnly',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SlideToggleComponent,
    },
  ],
})
export class SlideToggleComponent implements ControlValueAccessor {
  @ViewChild('inputEl', { static: true })
  inputElRef: ElementRef<HTMLInputElement>;

  @Input()
  value: boolean;
  @Output()
  valueChange = new EventEmitter<boolean>();

  @Input()
  disabled: boolean;
  @Input()
  readOnly: boolean;

  @Input()
  label: string;

  private touched = false;

  private onChange = (value) => {};

  private onTouched = () => {};

  writeValue(value: boolean): void {
    this.value = !!value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = !!isDisabled;
  }

  @HostListener('click')
  onHostClick() {
    if (!this.touched) {
      this.touched = true;
      this.onTouched?.();
    }
  }

  onCheckedChange() {
    const checked = !!this.inputElRef.nativeElement.checked;
    if (!!this.value !== checked) {
      this.value = checked;
      this.valueChange.emit(this.value);

      this.onChange?.(this.value);
    }
  }

  onLabelClick() {
    if (this.readOnly || this.disabled) {
      return;
    }

    this.inputElRef.nativeElement.checked =
      !this.inputElRef.nativeElement.checked;

    this.onCheckedChange();
  }
}
